/* Collection Filter Drawer – open/close + range slider + AJAX apply */
class CollectionFilterDrawer extends HTMLElement {
  constructor() {
    super();
    this.panel = this.querySelector('.cfd__panel');

    /* Event delegation so handlers survive DOM swaps */
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-cfd-overlay]')) return this.close();
      if (e.target.closest('[data-cfd-close]')) return this.close();
      if (e.target.closest('[data-cfd-apply]')) return this.apply();
      var clearLink = e.target.closest('.cfd__clear-top, .cfd__footer-clear');
      if (clearLink) { e.preventDefault(); return this.clearAll(); }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') this.close();
    });

    this.initRangeSliders();

    /* Back / forward navigation */
    window.addEventListener('popstate', () => {
      this.renderSection(new URLSearchParams(window.location.search), false);
    });
  }

  get sectionId() {
    var el = this.closest('[data-section-id]');
    return el ? el.dataset.sectionId : null;
  }

  open() {
    this.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (this.panel) this.panel.focus();
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  apply() {
    var form = this.querySelector('#CollectionFilterDrawerForm');
    if (!form) return;
    var params = new URLSearchParams();
    var formData = new FormData(form);
    for (var pair of formData.entries()) {
      params.append(pair[0], pair[1]);
    }
    /* Preserve current sort_by if set */
    var currentParams = new URLSearchParams(window.location.search);
    var sortBy = currentParams.get('sort_by');
    if (sortBy) params.set('sort_by', sortBy);

    this.close();
    this.renderSection(params, true);
  }

  clearAll() {
    var params = new URLSearchParams();
    var currentParams = new URLSearchParams(window.location.search);
    var sortBy = currentParams.get('sort_by');
    if (sortBy) params.set('sort_by', sortBy);
    this.close();
    this.renderSection(params, true);
  }

  /**
   * Fetch the section HTML with new params and swap grid + drawer content.
   * @param {URLSearchParams} params - filter/sort params
   * @param {boolean} push - whether to push a history entry
   */
  renderSection(params, push) {
    var sectionId = this.sectionId;
    if (!sectionId) {
      window.location.search = '?' + params.toString();
      return;
    }

    var searchStr = params.toString();
    var newUrl = window.location.pathname + (searchStr ? '?' + searchStr : '');
    if (push) history.pushState({}, '', newUrl);

    var fetchUrl = window.location.pathname + '?' + searchStr + (searchStr ? '&' : '') + 'section_id=' + sectionId;
    var self = this;

    var grid = document.getElementById('ProductGridContainer');
    if (grid) grid.style.opacity = '0.5';

    fetch(fetchUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        /* Swap product grid */
        var newGrid = temp.querySelector('#ProductGridContainer');
        var oldGrid = document.getElementById('ProductGridContainer');
        if (newGrid && oldGrid) {
          oldGrid.innerHTML = newGrid.innerHTML;
          oldGrid.style.opacity = '';
        }

        /* Swap drawer form (active states + counts) */
        var newForm = temp.querySelector('.cfd__form-wrap');
        var oldForm = self.querySelector('.cfd__form-wrap');
        if (newForm && oldForm) oldForm.innerHTML = newForm.innerHTML;

        /* Swap footer (apply count badge) */
        var newFooter = temp.querySelector('.cfd__footer');
        var oldFooter = self.querySelector('.cfd__footer');
        if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;

        self.initRangeSliders();
      })
      .catch(function() {
        window.location.search = '?' + searchStr;
      });
  }

  initRangeSliders() {
    this.querySelectorAll('.cfd__range-slider').forEach(function(slider) {
      var minInput = slider.querySelector('.cfd__range-input--min');
      var maxInput = slider.querySelector('.cfd__range-input--max');
      var fill = slider.querySelector('.cfd__range-fill');
      var parent = slider.closest('.cfd__price-range');
      var minDisplay = parent ? parent.querySelector('[data-range-min-display]') : null;
      var maxDisplay = parent ? parent.querySelector('[data-range-max-display]') : null;
      var rangeMax = parseFloat(slider.dataset.rangeMax) || 100;

      function update() {
        var minVal = parseFloat(minInput.value);
        var maxVal = parseFloat(maxInput.value);
        if (minVal > maxVal) {
          var t = minVal;
          minVal = maxVal;
          maxVal = t;
        }
        var leftPct = (minVal / rangeMax) * 100;
        var rightPct = ((rangeMax - maxVal) / rangeMax) * 100;
        fill.style.left = leftPct + '%';
        fill.style.right = rightPct + '%';
        if (minDisplay) minDisplay.textContent = '$' + Math.floor(minVal);
        if (maxDisplay) maxDisplay.textContent = '$' + Math.floor(maxVal);
      }

      if (minInput && maxInput) {
        minInput.addEventListener('input', update);
        maxInput.addEventListener('input', update);
        update();
      }
    });
  }
}

if (!customElements.get('collection-filter-drawer')) {
  customElements.define('collection-filter-drawer', CollectionFilterDrawer);
}
